/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "कल",
        "-2": "परसों",
        "0": "आज",
        "1": "कल",
        "2": "परसों",
        "future": {
          "one": "{0} दिन में",
          "other": "{0} दिन में"
        },
        "past": {
          "one": "{0} दिन पहले",
          "other": "{0} दिन पहले"
        }
      },
      "day-narrow": {
        "-1": "बीता कल",
        "-2": "परसों",
        "0": "आज",
        "1": "आने वाला कल",
        "2": "परसों",
        "future": {
          "one": "{0} दिन में",
          "other": "{0} दिन में"
        },
        "past": {
          "one": "{0} दिन पहले",
          "other": "{0} दिन पहले"
        }
      },
      "day-short": {
        "-1": "बीता कल",
        "-2": "परसों",
        "0": "आज",
        "1": "आने वाला कल",
        "2": "परसों",
        "future": {
          "one": "{0} दिन में",
          "other": "{0} दिन में"
        },
        "past": {
          "one": "{0} दिन पहले",
          "other": "{0} दिन पहले"
        }
      },
      "hour": {
        "0": "यह घंटा",
        "future": {
          "one": "{0} घंटे में",
          "other": "{0} घंटे में"
        },
        "past": {
          "one": "{0} घंटे पहले",
          "other": "{0} घंटे पहले"
        }
      },
      "hour-narrow": {
        "0": "यह घंटा",
        "future": {
          "one": "{0} घं॰ में",
          "other": "{0} घं॰ में"
        },
        "past": {
          "one": "{0} घं॰ पहले",
          "other": "{0} घं॰ पहले"
        }
      },
      "hour-short": {
        "0": "यह घंटा",
        "future": {
          "one": "{0} घं॰ में",
          "other": "{0} घं॰ में"
        },
        "past": {
          "one": "{0} घं॰ पहले",
          "other": "{0} घं॰ पहले"
        }
      },
      "minute": {
        "0": "यह मिनट",
        "future": {
          "one": "{0} मिनट में",
          "other": "{0} मिनट में"
        },
        "past": {
          "one": "{0} मिनट पहले",
          "other": "{0} मिनट पहले"
        }
      },
      "minute-narrow": {
        "0": "यह मिनट",
        "future": {
          "one": "{0} मि॰ में",
          "other": "{0} मि॰ में"
        },
        "past": {
          "one": "{0} मि॰ पहले",
          "other": "{0} मि॰ पहले"
        }
      },
      "minute-short": {
        "0": "यह मिनट",
        "future": {
          "one": "{0} मि॰ में",
          "other": "{0} मि॰ में"
        },
        "past": {
          "one": "{0} मि॰ पहले",
          "other": "{0} मि॰ पहले"
        }
      },
      "month": {
        "-1": "पिछला माह",
        "0": "इस माह",
        "1": "अगला माह",
        "future": {
          "one": "{0} माह में",
          "other": "{0} माह में"
        },
        "past": {
          "one": "{0} माह पहले",
          "other": "{0} माह पहले"
        }
      },
      "month-narrow": {
        "-1": "पिछला माह",
        "0": "इस माह",
        "1": "अगला माह",
        "future": {
          "one": "{0} माह में",
          "other": "{0} माह में"
        },
        "past": {
          "one": "{0} माह पहले",
          "other": "{0} माह पहले"
        }
      },
      "month-short": {
        "-1": "पिछला माह",
        "0": "इस माह",
        "1": "अगला माह",
        "future": {
          "one": "{0} माह में",
          "other": "{0} माह में"
        },
        "past": {
          "one": "{0} माह पहले",
          "other": "{0} माह पहले"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "अंतिम तिमाही",
        "0": "इस तिमाही",
        "1": "अगली तिमाही",
        "future": {
          "one": "{0} तिमाही में",
          "other": "{0} तिमाहियों में"
        },
        "past": {
          "one": "{0} तिमाही पहले",
          "other": "{0} तिमाही पहले"
        }
      },
      "quarter-narrow": {
        "-1": "अंतिम तिमाही",
        "0": "इस तिमाही",
        "1": "अगली तिमाही",
        "future": {
          "one": "{0} ति॰ में",
          "other": "{0} ति॰ में"
        },
        "past": {
          "one": "{0} ति॰ पहले",
          "other": "{0} ति॰ पहले"
        }
      },
      "quarter-short": {
        "-1": "अंतिम तिमाही",
        "0": "इस तिमाही",
        "1": "अगली तिमाही",
        "future": {
          "one": "{0} तिमाही में",
          "other": "{0} तिमाहियों में"
        },
        "past": {
          "one": "{0} तिमाही पहले",
          "other": "{0} तिमाहियों पहले"
        }
      },
      "second": {
        "0": "अब",
        "future": {
          "one": "{0} सेकंड में",
          "other": "{0} सेकंड में"
        },
        "past": {
          "one": "{0} सेकंड पहले",
          "other": "{0} सेकंड पहले"
        }
      },
      "second-narrow": {
        "0": "अब",
        "future": {
          "one": "{0} से॰ में",
          "other": "{0} से॰ में"
        },
        "past": {
          "one": "{0} से॰ पहले",
          "other": "{0} से॰ पहले"
        }
      },
      "second-short": {
        "0": "अब",
        "future": {
          "one": "{0} से॰ में",
          "other": "{0} से॰ में"
        },
        "past": {
          "one": "{0} से॰ पहले",
          "other": "{0} से॰ पहले"
        }
      },
      "week": {
        "-1": "पिछला सप्ताह",
        "0": "इस सप्ताह",
        "1": "अगला सप्ताह",
        "future": {
          "one": "{0} सप्ताह में",
          "other": "{0} सप्ताह में"
        },
        "past": {
          "one": "{0} सप्ताह पहले",
          "other": "{0} सप्ताह पहले"
        }
      },
      "week-narrow": {
        "-1": "पिछला सप्ताह",
        "0": "इस सप्ताह",
        "1": "अगला सप्ताह",
        "future": {
          "one": "{0} सप्ताह में",
          "other": "{0} सप्ताह में"
        },
        "past": {
          "one": "{0} सप्ताह पहले",
          "other": "{0} सप्ताह पहले"
        }
      },
      "week-short": {
        "-1": "पिछला सप्ताह",
        "0": "इस सप्ताह",
        "1": "अगला सप्ताह",
        "future": {
          "one": "{0} सप्ताह में",
          "other": "{0} सप्ताह में"
        },
        "past": {
          "one": "{0} सप्ताह पहले",
          "other": "{0} सप्ताह पहले"
        }
      },
      "year": {
        "-1": "पिछला वर्ष",
        "0": "इस वर्ष",
        "1": "अगला वर्ष",
        "future": {
          "one": "{0} वर्ष में",
          "other": "{0} वर्ष में"
        },
        "past": {
          "one": "{0} वर्ष पहले",
          "other": "{0} वर्ष पहले"
        }
      },
      "year-narrow": {
        "-1": "पिछले साल",
        "0": "इस साल",
        "1": "अगले साल",
        "future": {
          "one": "{0} वर्ष में",
          "other": "{0} वर्ष में"
        },
        "past": {
          "one": "{0} वर्ष पहले",
          "other": "{0} वर्ष पहले"
        }
      },
      "year-short": {
        "-1": "पिछला वर्ष",
        "0": "इस वर्ष",
        "1": "अगला वर्ष",
        "future": {
          "one": "{0} वर्ष में",
          "other": "{0} वर्ष में"
        },
        "past": {
          "one": "{0} वर्ष पहले",
          "other": "{0} वर्ष पहले"
        }
      }
    },
    "locale": "hi"
  });
}